import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'debug',
    name: 'debug',
    component: () => import('./layouts/DebugLayout.vue'),
    children: [
      {
        name: 'debug__index',
        path: '',
        component: () => import('./views/IndexView.vue'),
      },
    ],
  },
]

export default routes
